.indicator {
  box-sizing: content-box;
  width: 16px;
  height: 16px;
  padding: 8px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.dot {
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: 2px solid var(--colors-grays-mid);
  border-radius: 50%;
}

.indicator_selected .dot {
  border-color: var(--colors-primary-dark);
  background: var(--colors-primary-main);
}

.indicator:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.indicator:enabled:hover,
.indicator:enabled:focus-visible {
  background: var(--colors-grays-ultralight);
}

.indicator:enabled:hover .dot,
.indicator:enabled:focus-visible .dot {
  border-color: var(--colors-grays-dark);
}

.indicator_selected:enabled:hover .dot,
.indicator_selected:enabled:focus-visible .dot {
  border-color: var(--colors-primary-dark);
  background: var(--colors-primary-dark);
}

@media (--reefer-media-tablet-min) {
  .indicator {
    width: 18px;
    height: 18px;
    padding: 10px;
  }
}
